import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { useAnalyticsEvents } from "@/hooks/useAnalyticsEvents";
import { Skeleton } from "@/components/ui/skeleton";
import { Activity } from "lucide-react";
import { formatDistanceToNow } from "date-fns";
import { de } from "date-fns/locale";

interface EventsLiveTableProps {
  limit?: number;
}

export const EventsLiveTable = ({ limit = 20 }: EventsLiveTableProps) => {
  const { data: events, isLoading } = useAnalyticsEvents({ limit });

  const getEventColor = (eventName: string) => {
    if (eventName.includes('lead')) return 'default';
    if (eventName.includes('click')) return 'secondary';
    if (eventName.includes('view')) return 'outline';
    return 'secondary';
  };

  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Activity className="h-5 w-5" />
            Live Event Feed
          </CardTitle>
          <CardDescription>Neueste Aktivitäten in Echtzeit</CardDescription>
        </CardHeader>
        <CardContent>
          <Skeleton className="h-[300px]" />
        </CardContent>
      </Card>
    );
  }

  if (!events || events.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Activity className="h-5 w-5" />
            Live Event Feed
          </CardTitle>
          <CardDescription>Neueste Aktivitäten in Echtzeit</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">Keine Events verfügbar</p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Activity className="h-5 w-5 animate-pulse text-primary" />
          Live Event Feed
        </CardTitle>
        <CardDescription>Neueste Aktivitäten in Echtzeit</CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Event</TableHead>
              <TableHead>Seite</TableHead>
              <TableHead>Kategorie</TableHead>
              <TableHead>Zeit</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {events.map((event) => (
              <TableRow key={event.id}>
                <TableCell>
                  <Badge variant={getEventColor(event.event_name)}>
                    {event.event_name}
                  </Badge>
                </TableCell>
                <TableCell className="font-mono text-xs">
                  {event.page_path || '-'}
                </TableCell>
                <TableCell className="text-sm text-muted-foreground">
                  {event.event_category || '-'}
                </TableCell>
                <TableCell className="text-sm text-muted-foreground">
                  {formatDistanceToNow(new Date(event.created_at), { 
                    addSuffix: true,
                    locale: de 
                  })}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};
